module.exports = __webpack_public_path__ + "static/media/alipay.c0c84bd0.svg";